<iframe
    *ngFor="let report of _reports"
    [title]="report.reportName"
    width="100%"
    height="100%"
    [src]="report.url"
    allowFullScreen="true"
>
</iframe>
